/**
 * Box shadow tokens.
 * Softer, more subtle shadows for a premium feel.
 */

export const shadows = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.04)',
  md: '0 2px 8px -2px rgb(0 0 0 / 0.08), 0 1px 2px -1px rgb(0 0 0 / 0.04)',
  lg: '0 8px 24px -4px rgb(0 0 0 / 0.08), 0 2px 6px -2px rgb(0 0 0 / 0.04)',
  xl: '0 16px 40px -8px rgb(0 0 0 / 0.1), 0 4px 12px -4px rgb(0 0 0 / 0.05)',
  focus: '0 0 0 3px rgb(44 105 255 / 0.25)',
};
